import { createFileRoute } from '@tanstack/react-router';

import { client } from '@@api/client';
import { handleLoaderError } from '@@router/handleLoaderError';

import { EditLeagueForm } from '../-components/LeagueForm';

export const Route = createFileRoute('/_authenticated/teams/leaguesAndTournaments/$id')({
    context: ({ params }) => ({
        leagueQuery: client.liveticker.leagues.get.queryOptions(
            { params: { id: Number(params.id) } },
            { refetchOnWindowFocus: false },
        ),
    }),
    loader: ({ context }) =>
        context.queryClient
            .query({ ...context.leagueQuery, staleTime: 'static' })
            .catch(handleLoaderError),
    component: EditLeagueForm,
});
